<template>
  <section class="border-t border-default/60 bg-default">
    <UContainer class="py-12 sm:py-14">
      <div class="mx-auto max-w-md space-y-4">
        <h2 class="text-center text-xl font-semibold">
          {{ title || item?.name || 'راهنمای شخصی' }}
        </h2>
        <p
          v-if="subtitle"
          class="text-center text-sm text-muted"
        >
          {{ subtitle }}
        </p>
        <div
          v-if="!guideId || builderPreview"
          class="rounded-2xl border border-dashed p-6 text-center text-sm text-muted"
        >
          راهنمای شخصی‌سازی‌شده
        </div>
        <LeadFlowShell
          v-else
          :labels="['سؤالات', 'موبایل']"
          :step="step"
          :loading="saving"
          :next-disabled="step === 1 && !isCompleteIrMobile(phone)"
          :show-next="!guide"
          @next="next"
          @back="step = 0"
        >
          <LeadQuestionFields
            v-if="step === 0"
            v-model="answers"
            :questions="item?.segments ?? []"
          />
          <AuthPhoneInput
            v-else-if="!guide"
            v-model="phone"
          />
          <div
            v-else
            class="space-y-2"
          >
            <p class="font-semibold">
              {{ guide.title }}
            </p>
            <p class="text-sm leading-7 text-muted">
              {{ guide.body }}
            </p>
          </div>
        </LeadFlowShell>
        <p
          v-if="error"
          class="text-center text-sm text-error"
        >
          {{ error }}
        </p>
      </div>
    </UContainer>
  </section>
</template>

<script setup lang="ts">
import AuthPhoneInput from '~/components/auth/PhoneInput.vue'
import type { LeadQuestion } from '~/utils/leads/questions'
import { isCompleteIrMobile } from '~/utils/phone'
import { apiErrorMessage } from '~/utils/apiError'

const props = defineProps<{
  title?: string
  subtitle?: string
  guideId?: string
  builderPreview?: boolean
}>()

const item = ref<{ name: string; segments: LeadQuestion[] } | null>(null)
const answers = ref<Record<string, unknown>>({})
const phone = ref('')
const step = ref(0)
const saving = ref(false)
const error = ref('')
const guide = ref<{ title: string; body: string } | null>(null)

if (import.meta.client && props.guideId && !props.builderPreview) {
  $fetch<{ item: NonNullable<typeof item.value> }>(`/api/leads/guides/${props.guideId}`)
    .then((res) => { item.value = res.item })
    .catch(() => {})
}

async function next() {
  if (step.value === 0) {
    step.value = 1
    return
  }
  if (!props.guideId) return
  saving.value = true
  error.value = ''
  try {
    const res = await $fetch<{ item: { title?: string; body?: string } | string }>(`/api/leads/guides/${props.guideId}/submit`, {
      method: 'POST',
      body: { answers: answers.value, phone: phone.value },
    })
    const mapped = res.item
    guide.value = typeof mapped === 'string'
      ? { title: item.value?.name || 'راهنما', body: mapped }
      : { title: mapped.title || item.value?.name || 'راهنما', body: mapped.body || '' }
  }
  catch (err) {
    error.value = apiErrorMessage(err, 'ارسال ناموفق بود')
  }
  finally {
    saving.value = false
  }
}
</script>
